import { render, staticRenderFns } from "./DataFieldChangeReason.vue?vue&type=template&id=cf7ebe3e"
import script from "./DataFieldChangeReason.vue?vue&type=script&lang=ts"
export * from "./DataFieldChangeReason.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports